import React from 'react'
import Button from '@Components/Buttons/Button'
import CheckBox from '@Components/Selectors/Checkbox'
import { SearchResultPartyDetails } from '@Entities/party-details'
import WriterSelectionCard from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/WriterSelectionCard'

export const MINIMUM_WRITERS_TO_MERGE = 2

interface SelectWritersStepProps {
    writers: SearchResultPartyDetails[]
    selectedWriterIpIds: string[]
    toggleWriter(writerIpId: string): void
    onBack(): void
    onNext(): void
}

const SelectWritersStep = (props: SelectWritersStepProps) => {
    const { writers, selectedWriterIpIds, toggleWriter, onBack, onNext } = props

    return (
        <>
            <p>Select which names you would like to merge:</p>
            <div className="writer-selection-list">
                {writers.map((writer) => (
                    <WriterSelectionCard key={writer.ipId} writer={writer}>
                        <CheckBox
                            mainColor
                            id={`merge-writer-${writer.ipId}`}
                            ariaLabel={writer.name}
                            checked={selectedWriterIpIds.includes(String(writer.ipId))}
                            onClick={() => toggleWriter(String(writer.ipId))}
                        />
                    </WriterSelectionCard>
                ))}
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={onBack}>
                    Back
                </Button>
                <Button
                    mainColor
                    type="primary"
                    disabled={selectedWriterIpIds.length < MINIMUM_WRITERS_TO_MERGE}
                    onClick={onNext}
                >
                    Next
                </Button>
            </div>
        </>
    )
}
export default SelectWritersStep
